import { isFinite, toNumber } from "lodash";
import { GetServerSidePropsContext } from "next";
import { useRouter } from "next/router";

export function usePaginationCurrentQuery() {
  const router = useRouter();

  return parseCurrent(router.query.current);
}

export function getServerSideCurrentQuery(context: GetServerSidePropsContext) {
  return parseCurrent(context.query.current);
}

function parseCurrent(current?: string | string[]) {
  const currentQuery = toNumber(current);
  return isFinite(currentQuery) ? currentQuery : 1;
}
